import { apiClient } from './client';
import type { ClientsPageMeta, ClientTestGroups } from './clients';

/**
 * Строка каталога тестов БЕЗ привязки к клиенту — GET /tests/catalog.
 * Используется только шагами "Тесты"/"Цены" мастера создания клиента
 * (ClientCreatePage) — там ещё нет id клиента, поэтому нет и понятия
 * "подключён"/"активен" (см. докблок TestCatalogController в Laravel).
 */
export interface TestCatalogRow {
  id: number;
  name: string;
  category: string | null;
  version: string | null;
  basePrice: number;
}

export interface FetchTestCatalogParams {
  search?: string;
  group?: string;
  page?: number;
}

/** Постранично — каталог растёт вместе с main_tests, см. докблок TestCatalogController::index() в Laravel. */
export interface TestCatalogPage {
  items: TestCatalogRow[];
  meta: ClientsPageMeta;
}

export async function fetchTestCatalog(
  scope: 'library' | 'monoscale',
  params: FetchTestCatalogParams = {},
): Promise<TestCatalogPage> {
  const { data } = await apiClient.get<TestCatalogPage>('/tests/catalog', {
    params: { scope, ...params },
  });
  return data;
}

/** Тот же формат, что fetchClientTestGroups() — общий сентинел "Группа не задана". */
export async function fetchTestCatalogGroups(scope: 'library' | 'monoscale'): Promise<ClientTestGroups> {
  const { data } = await apiClient.get<ClientTestGroups>('/tests/catalog/groups', {
    params: { scope },
  });
  return data;
}

/**
 * Правка глобальной стоимости теста — страница "Каталог" в сайдбаре
 * (TestsCatalogPage.tsx), отдельные от мастера создания клиента права
 * (platform*.tarif, не customers.add — см. докблок TestCatalogController в Laravel).
 */
export async function updateTestCatalogCost(id: number, cost: number): Promise<TestCatalogRow> {
  const { data } = await apiClient.put<TestCatalogRow>(`/tests/catalog/${id}`, { cost });
  return data;
}

/** Отчёт теста (MainTestVariants в Laravel) — у моношкальных тестов отчётов не бывает. */
export interface TestReportRow {
  id: number;
  title: string;
  cost: number;
}

export async function fetchTestReports(testId: number): Promise<TestReportRow[]> {
  const { data } = await apiClient.get<TestReportRow[]>(`/tests/catalog/${testId}/reports`);
  return data;
}

export async function updateTestReportCost(
  testId: number,
  reportId: number,
  cost: number,
): Promise<TestReportRow> {
  const { data } = await apiClient.put<TestReportRow>(`/tests/catalog/${testId}/reports/${reportId}`, { cost });
  return data;
}
